// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inline-datepicker[data-v-0f12261c]{margin:0 auto 1rem;max-width:310px}", "",{"version":3,"sources":["webpack://./resources/client/components/form/FormFieldDatePicker.vue"],"names":[],"mappings":"AACA,oCAEE,kBAAA,CADA,eACF","sourcesContent":["\n.inline-datepicker {\n  max-width: 310px;\n  margin: 0 auto 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
